import { render, staticRenderFns } from "./videoModel.vue?vue&type=template&id=32dbc9a8&scoped=true"
import script from "./videoModel.vue?vue&type=script&lang=js"
export * from "./videoModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dbc9a8",
  null
  
)

export default component.exports